$(document).ready(function(){
    'use strict'

    //Находим элементы input с разным типом
    const inputBirthday = $('.cell-input.cell-input--birthday')
    const inputPhone = $('.cell-input.cell-input--phone')

    //Маска для даты
    inputBirthday.inputmask("99.99.9999");

    //Маска для телефона
    inputPhone.inputmask("+7 (999) 999-99-99");
});
